import classNames from "classnames";
import * as React from "react";

import { useEphemeralWorkspaceStateLoading } from "../WorkspaceCtx";

import { KeywordFilter } from "./filter";
import { FilterInput } from "./FilterInput";
import styles from "./Topics.module.css";
import { TopicTree, TopicTreeSkeleton } from "./TopicTree";
import { useTopicFilterRequest } from "./useTopicFilterRequest";

interface TopicsProps {
  fileId: string | undefined;
  className?: classNames.Argument;
  header?: React.ReactNode;
}

export function Topics(props: TopicsProps) {
  const { fileId, header } = props;

  const externalFilterRequest = useTopicFilterRequest();

  const [filter, setFilter] = React.useState<KeywordFilter>({
    type: "keyword",
    term: "",
  });

  // Ref for accessing the filter input element
  const inputRef = React.useRef<HTMLInputElement>(null);

  const isDataLoading = useEphemeralWorkspaceStateLoading();

  React.useEffect(
    function applyExternalFilterRequest() {
      if (!externalFilterRequest) {
        return;
      }

      if (inputRef.current) {
        inputRef.current.value = externalFilterRequest.term;
      }

      // Apply filter since updating the ref doesn't trigger a change event
      setFilter({ type: "keyword", term: externalFilterRequest.term });
    },
    [externalFilterRequest],
  );

  const handleFilterChange = React.useCallback((filter: KeywordFilter) => {
    setFilter(filter);
  }, []);

  return (
    <div className={classNames(props.className, styles.container)}>
      {header}
      <FilterInput
        ref={inputRef}
        className={styles.filter}
        onFilterChange={handleFilterChange}
      />
      {isDataLoading ? (
        <TopicTreeSkeleton estimatedTopicCount={15} />
      ) : (
        <TopicTree fileId={fileId} filter={filter} />
      )}
    </div>
  );
}
